import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  { path: '/login', component: () => import('@/views/Login.vue') },
  {
    path: '/',
    component: () => import('@/views/Layout.vue'),
    redirect: '/map-month',
    children: [
      { path: 'map-month', component: () => import('@/views/MapMonth.vue') },
      { path: 'map-ytd', component: () => import('@/views/MapYtd.vue') },
      { path: 'history', component: () => import('@/views/History.vue') },
{ path: 'region', component: () => import('@/views/Region.vue') },
      { path: 'export', component: () => import('@/views/Export.vue') },
      { path: 'grid-map', component: () => import('@/views/GridMap.vue') },
      { path: 'weather-history', component: () => import('@/views/WeatherHistory.vue') },
      { path: 'data-sync', component: () => import('@/views/DataSync.vue') },
      { path: 'user-manage', component: () => import('@/views/UserManage.vue') },
      { path: 'station', component: () => import('@/views/Station.vue') },
      { path: 'station-psh/:id', component: () => import('@/views/StationPsh.vue') },
      { path: 'station-export', component: () => import('@/views/StationExport.vue') },
    ]
  },
  { path: '*', redirect: '/' }
]

const router = new VueRouter({ routes })

router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('psh_token')
  if (to.path !== '/login' && !token) return next('/login')
  next()
})

export default router
